$(document).ready(function(){

  const tabNav = document.querySelectorAll('.explorer-nav button');
  const tabs = document.querySelectorAll('.explorer-grid');
  let devSlider = null; // Variable to hold the slick object
  let activeTabIndex = 0; // Variable to hold the index of the active tab

  // Function to initialize the carousel
  const initCarousel = () => {
    devSlider = $('.devExplorerSlide').slick({
      dots: false,
      infinite: false,
      speed: 300,
      nextArrow: "<button type='button' class='slick-next slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrow-right' viewBox='0 0 16 16'> <path fill-rule='evenodd' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8'/> </svg></button>",
      prevArrow: "<button type='button' class=' slick-prev slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrow-left' viewBox='0 0 16 16'> <path fill-rule='evenodd' d='M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8'/> </svg></button>",
      slidesToShow: 4.5,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        }
      ]
    });
  };

  // Function to unslick the carousel
  const unslickCarousel = () => {
    if (devSlider !== null) {
      devSlider.slick('unslick');
    }
  };

  tabNav.forEach((button, index) => {
    button.addEventListener('click', () => {
      // Unslick the carousel before switching tabs
      unslickCarousel();

      tabNav.forEach((button, buttonIndex) => {
        button.classList.remove('active');
        if(buttonIndex === index) {
          button.classList.add('active');
          activeTabIndex = index; // Update the active tab index
        }
      });
      tabs.forEach((tab, tabIndex) => {
        tab.classList.remove('active');
        if(tabIndex === index) {
          tab.classList.add('active');
        }
      });
      // matchExplorerHeight();

      // Slick the carousel again after switching tabs
      initCarousel();
    });
  });

  // Initialize the carousel on the active tab when the page loads
  initCarousel();



// other section on same page

const tabNavre = document.querySelectorAll('.explorer-navv button');
  const tabsre = document.querySelectorAll('.explorer-gridd');
  let devSliderr = null; // Variable to hold the slick object
  let activeTabIndexx = 0; // Variable to hold the index of the active tab

  // Function to initialize the carousel
  const initCarouselre = () => {
    devSliderr = $('.devExplorerSliderr').slick({
      dots: false,
      infinite: false,
      speed: 300,
      nextArrow: "<button type='button' class='slick-next slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrow-right' viewBox='0 0 16 16'> <path fill-rule='evenodd' d='M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8'/> </svg></button>",
      prevArrow: "<button type='button' class=' slick-prev slick-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrow-left' viewBox='0 0 16 16'> <path fill-rule='evenodd' d='M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8'/> </svg></button>",
      slidesToShow: 1,
      slidesToScroll: 1
    });
  };

  // Function to unslick the carousel
  const unslickCarouselre = () => {
    if (devSliderr !== null) {
      devSliderr.slick('unslick');
    }
  };

  tabNavre.forEach((buttonre, indexx) => {
    buttonre.addEventListener('click', () => {
      // Unslick the carousel before switching tabs
      unslickCarouselre();

      tabNavre.forEach((buttonre, buttonIndexx) => {
        buttonre.classList.remove('activee');
        if(buttonIndexx === indexx) {
          buttonre.classList.add('activee');
          activeTabIndexx = indexx; // Update the active tab index
        }
      });
      tabsre.forEach((tabss, tabIndexx) => {
        tabss.classList.remove('activee');
        if(tabIndexx === indexx) {
          tabss.classList.add('activee');
        }
      });
      // matchExplorerHeight();

      // Slick the carousel again after switching tabs
      initCarouselre();
    });
  });

  // Initialize the carousel on the active tab when the page loads
  initCarouselre();


/*

// Scrolling
let isDownEx = false;
let wasDragEx = false;
let startXEx;
let scrollLeftEx;

// Drag stops
const endEx = (slider, e) => {
  isDownEx = false;
  slider.classList.remove('active-drag');
}

// Drag starts
const startEx = (slider, e) => {
  isDownEx = true;
  wasDragEx = false;
  slider.classList.add('active-drag');
  startXEx = e.pageX || e.touches[0].pageX - slider.offsetLeft;
  scrollLeftEx = slider.scrollLeft;
}

// Drag in progress
const moveEx = (slider, e) => {
  if (!isDownEx) return;

  e.preventDefault();
  const x = e.pageX || e.touches[0].pageX - slider.offsetLeft;
  const dist = x - startXEx;
  slider.scrollLeft = scrollLeftEx - dist;
  if(dist < -1) {
    wasDragEx = true;
  } 
}

// Select scrollers
const slidersEx = document.querySelectorAll('.explorer-grid');

// Attach events
slidersEx.forEach(slider => {
  slider.addEventListener('mousedown', (e) => startEx(slider, e));
  slider.addEventListener('mousemove', (e) => moveEx(slider, e));
  slider.addEventListener('mouseleave', (e) => endEx(slider, e));
  slider.addEventListener('mouseup', (e) => endEx(slider, e));
});

// If isn't a drag then allow link click
$('.explorer-grid a').on('click', function(e) {
  //console.log('wasDrag', wasDrag);
  if(wasDragEx) {
    e.preventDefault();
  } 
});

function matchExplorerHeight() {
  var getDivs = document.getElementsByClassName('match-height-ex');
  var arrayLength = getDivs.length;
  var heights = [];

  for (var i = 0; i < arrayLength; i++) {
    getDivs[i].style.height = 'auto';
    heights.push(getDivs[i].offsetHeight);
  }

  function getHighest() {
    return Math.max(...heights);
  }

  var tallest = getHighest();

  for (var i = 0; i < getDivs.length; i++) {
    getDivs[i].style.height = tallest + "px";
  }
}

matchExplorerHeight();

window.addEventListener('resize', function() {
  setTimeout(function(){
    matchExplorerHeight();
  });
}); */
})
